import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { GtwElementsBaseUrlsModel } from '../../../../app/shared/_models/gtw-elements-base-urls.model';
import { FgnOverrides163JComponentService } from './fgn-overrides163j.service';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-fgn-overrides163j',
    templateUrl: './fgn-overrides163j.component.html',
    styleUrls: ['./fgn-overrides163j.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FgnOverrides163jComponent implements OnInit, OnDestroy {

  baseGlobalParams: any = {};
  baseURLs: GtwElementsBaseUrlsModel = {
    admin: '',
    api: '/gtw',
    custom: '',
    efile: '',
    pdfEngine: '',
    bulkPdfEngine: ''
  };

  private ssoId = '';
  private checkLockedObj: any = [];
  private rowData: any = {};
  private modalName = '';
  private filterParams: any = {};
  isViewOnly = false;
  enableButton = true;
  clob_settings: { tax_year: number; scenario: number; jcd_key: number } = {
    tax_year: 0,
    scenario: 0,
    jcd_key: 0
  };
  clob_data: any = [];

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  subscriptions = new Subscription();

  constructor(
    private FgnOverrides163JComponentService: FgnOverrides163JComponentService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.init();
    this.subscriptions.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
    this.subscriptions.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const gc = generalConfigFromGlobal(this.gtwGlobal) as GtwElementsBaseUrlsModel;
    const apiRoot = gc.api || (gc as any).base_url || '';
    this.baseURLs = { ...gc, api: apiRoot || gc.api || '/gtw' };
    this.baseGlobalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    this.filterParams = normalizeFilterParams(activeScreen) || {};
    this.checkLockedObj = this.baseGlobalParams?.checkLockedbj ?? this.checkLockedObj;

    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow)
      ? extractObject(rawRow[0]?.data ?? rawRow[0])
      : extractObject(rawRow);

    this.modalName = this.baseGlobalParams?.modalScreen?.modal_name || this.modalName;
    const sso = this.gtwApp?.USER_SETTINGS?.user?.sso_id;
    this.ssoId = sso != null && sso !== '' ? String(sso) : this.ssoId;
  }

  checkInputType(): boolean {
    if (
      Number.isInteger(parseInt(this.ssoId + '', 10)) &&
      Object.keys(extractObject(this.rowData)).length > 0 &&
      this.modalName != null &&
      this.modalName !== '{{ctrl.modalName}}' &&
      Object.keys(extractObject(this.filterParams)).length > 0
    ) {
      return true;
    }
    return false;
  }

  init(): void {
    if (this.checkInputType()) {
      // row-driven delete confirmation; no extra UI state
    }
  }

  save(): void {
    this.enableButton = false;
    this.clob_data = [];
    this.clob_settings.tax_year = this.filterParams.tax_year;
    this.clob_settings.scenario = this.filterParams.scenario;
    this.clob_settings.jcd_key = this.baseGlobalParams.jcd_key;
    const tempObj = {
      COMBINATION_KEY: this.rowData.COMBINATION_KEY,
      HO_COMBINATION_KEY: this.rowData.HO_COMBINATION_KEY,
      ACCT_KEY: this.rowData.ACCT_KEY,
      CHART_KEY: this.rowData.CHART_KEY,
      TRANS_HEADER_KEY: this.rowData.TRANS_HEADER_KEY === undefined ? 0 : this.rowData.TRANS_HEADER_KEY,
      TRANS_DETAILS_KEY: this.rowData.TRANS_DETAILS_KEY === undefined ? 0 : this.rowData.TRANS_DETAILS_KEY
    };
    this.clob_data.push(tempObj);
    this.subscriptions.add(
      this.FgnOverrides163JComponentService.saveData(
        this.baseURLs.api,
        this.clob_data,
        this.clob_settings,
        this.baseGlobalParams,
        this.checkLockedObj,
        this.filterParams,
        this.ssoId
      ).subscribe(
        data => {
          if (data.callSuccess == '1') {
            this.FgnOverrides163JComponentService.openSnackBar('Data Saved Successfully', 'gtw-snackbar--green');
            this.requestGridUpdate.emit('refresh');
          } else {
            this.enableButton = true;
            this.FgnOverrides163JComponentService.openSnackBar(
              'Error Saving Data. ' + data.errorMessage,
              'gtw-snackbar--red'
            );
          }
        },
        () => {
          console.log('Error while saving');
        }
      )
    );
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }
}
